<template>
  <div class="downLoadBox">
    <div class="main">
      <div class="info">
        <div>
          <img
            class="logo"
            src="@/assets/img/h5/download/logo.png"
            alt=""
          />
        </div>
        <div>
          <img
            class="slogan"
            src="@/assets/img/h5/download/slogan.png"
            alt=""
          />
        </div>
        <!-- <p class="name">云端美育</p>
        <p class="tip">艺术点亮生活</p> -->
      </div>
    </div>
    <div class="down">
      <p @click="util.downLoad(this)">立即下载</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.downLoadBox {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10vh 32px;
  color: rgba(45, 45, 45, 1);
  background: #fff;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  .main {
    flex: 1;
    .info {
      text-align: center;
      .logo {
        height: 144px;
        width: auto;
      }
      .slogan {
        margin-top: 24px;
        height: 26px;
        width: auto;
      }
      /* img {
        width: 72px;
        height: 72px;
      }
      .name {
        font-size: 22px;
        line-height: 30px;
        font-weight: 600;
        margin-top: 33px;
      }
      .tip {
        font-size: 18px;
        line-height: 25px;
        margin-top: 12px;
        font-weight: 300;
      } */
    }
  }
  .down {
    p {
      background: linear-gradient(315deg, #d44c48 0%, #ee816d 100%);
      border-radius: 24px;
      font-size: 14px;
      line-height: 20px;
      color: rgba(255, 255, 255, 1);
      padding: 14px 0;
      text-align: center;
      font-weight: bolder;
    }
  }
}
</style>